import { BordOneToneIcon, NudosHoverText } from '../NudosComponents';
import { bordColorTheme } from '../../styles/styles.constants';
import NudosProductPills from '../NudosComponents/NudosProductPills/NudosProductPills';
import { IInTransitLocation } from 'types/products';

import './SelectableToolCard.scss';

export interface IToolData {
  id?: number;
  productId?: number | null;
  name?: string | null;
  pills?: { [key: string]: string | null };
  image?: string | null;
  brand?: string | null;
  brandImage?: string | null;
  serial?: string | null;
  isAdditionalProduct?: boolean | null;
  isMarkedNotDelivered?: boolean | null;
  inTransit?: IInTransitLocation| null;
  isUploaded?: boolean | null;
}

interface ISelectableToolCardProps {
  tool: IToolData;
  isSelected?: boolean;
  onSelectionChange?: () => void;
  showCheckbox?: boolean;
  customClassName?: string;
}

/**
 * Tarjeta seleccionable para mostrar información de una herramienta
 * @param tool - La herramienta a mostrar
 * @param isSelected - Indica si la herramienta está seleccionada
 * @param onSelectionChange - Función para manejar el cambio de selección
 * @param showCheckbox - Indica si se debe mostrar el checkbox
 * @param customClassName - Clase personalizada para el componente
 */
const SelectableToolCard = ({
  tool,
  isSelected = false,
  onSelectionChange,
  showCheckbox = false,
  customClassName = ''
}: ISelectableToolCardProps) => {
  const characteristicsPills = (): JSX.Element | undefined => {
    if (!tool.pills || Object.keys(tool.pills)?.length === 0) return undefined;
    return <NudosProductPills pills={tool.pills} characterLimit={12} customHeight={20} xPadding="4px" yPadding="4px" />;
  };

  return (
    <div className={`selectableToolCard ${customClassName}`}>
      <div className="cardContent">
        {showCheckbox && (
          <button
            className={`selectionButton ${isSelected ? 'selected' : 'unselected'}`}
            onClick={onSelectionChange}
            type="button"
          >
            <BordOneToneIcon variant="x" customWidth="16px" stroke={isSelected ? 'white' : 'transparent'} />
          </button>
        )}
        <div className="cardMainContent">
          <div className="imageContainer">
            {tool.image && <img src={tool.image} alt={tool.name || ''} className="imageCard" />}
          </div>
          <div className="toolInfoContainer">
            <div className="toolNameContainer">
              {tool.brandImage && <img src={tool.brandImage} alt={tool.brand || ''} className="iconCard" />}
              <NudosHoverText customClassName="toolName" text={tool.name || ''} charactersLimit={55} onlyIfTruncated />
            </div>
            <div className="toolDetailsContainer">
              {characteristicsPills()}
              <div className="serialContainer">
                <BordOneToneIcon variant="barCode2" customWidth="12px" stroke={bordColorTheme.stroke.default} />
                <span className="serialText">{tool?.serial || 'Sin serial'}</span>
              </div>
            </div>
          </div>
          {tool.isAdditionalProduct && (
            <div className="additionalProductBadge">
              <p className="additionalProductText">Herramienta adicional</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectableToolCard;
